<template>
  <h3 class="colorBlue">
    <i class="primaryColor" :class="icon"></i>
    {{ title }}
  </h3>
</template>
<style scoped>
h3 {
  font-size: 15px;
  z-index: 999;
}
i {
  font-size: 15px;
}
</style>
<script>
export default {
  name: "sectiontitle",
  props: {
    title: String,
    icon: String,
  },
};
</script>
